export type OrderCountdownConfig = {
  enabled: boolean
  wording: string
  closedWording: string
  closedSubtext: string
  closedBadge: string
  timeZone: 'Pacific/Auckland'
  mode: 'weekly'
  openWeekday: number
  openHour: number
  openMinute: number
  cutoffWeekday: number
  cutoffDate: string | null
  cutoffHour: number
  cutoffMinute: number
}

export const orderV3Config = {
  popularPackQuantity: 6,
  countdown: {
    enabled: true,
    wording: "This week's drop ends in",
    closedWording: "This week's drop is closed",
    closedSubtext: 'Orders reopen Monday',
    closedBadge: 'Closed',
    timeZone: 'Pacific/Auckland',
    mode: 'weekly',
    // JavaScript weekday convention: Sunday = 0 through Saturday = 6.
    openWeekday: 1,
    openHour: 0,
    openMinute: 0,
    cutoffWeekday: 5,
    cutoffDate: null,
    cutoffHour: 18,
    cutoffMinute: 0,
  } satisfies OrderCountdownConfig,
} as const
